import React, { useEffect, useState } from "react";
import { Box, Dialog, Modal, Slide, Typography } from "@mui/material";
import { Col, Container, Row } from "reactstrap";
import CustomButton from "../../../../components/CustomButton/index.js";
import document from "../../../../assets/Document.png";
import { BasicDetails } from "./basicDetails.js";
import { DocumentUpload } from "./documentUpload.js";
import { ApprovalSetting } from "./approvalSetting.js";
import { endpoint } from "../common/constant/index.js";
import { dropdownMapping } from "../unAssigned/studentCharges/common.js";
import { dropdownMapping as dropdownMappingNew  } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import closeIcon from "../../../../assets/CloseSquare.png";
import infoIcon from "../../../../assets/concessionInfo.png";
import downarrow from "../../../../assets/downarrow.png";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  fetchDeletePromisedData,
} from "../common/utils/methods/commonMethods/utilityMethod.js";
import CustomLoader from "../common/commonComponents/Loader/loader.js";
import "./index.scss";
import { DetailCard } from "./detailCard";
import {
  failureToast,
  successToast,
} from "../common/utils/methods/toasterFunctions/function.js";
import { putpost } from "services/http.js";
import { ConfirmationDeleteDialog } from "../common/commonComponents/index.js";
import Filter from "./Filter.jsx";
import { useLocation } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const EMPTY_FORM = {
  region: [],
  businessAreas: [],
  courseCategories: [],
  academicGroup: [],
  term: [],
  l1ApprovalPercentage: "",
  l1ApprovalRoles: [],
  l2ApprovalPercentage: "",
  l2ApprovalRoles: [],
  l3ApprovalPercentage: "",
  l3ApprovalRoles: [],
  documentUploadPercentCriteria: "",
  status: "ACTIVE",
};

const ClosedStep = ({ title, setStep }) => {
  return (
    <div className="closed-step justify-content-between">
      <div>{title}</div>
      <div className="cursor" onClick={setStep}>
        <img height={6} src={downarrow} />
      </div>
    </div>
  );
};

const ConcessionWorkflow = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const location = useLocation();
  const isRegularCharges = location?.pathname?.includes("regular-charges");
  const chargeType = isRegularCharges ? "REGULAR" : "OTHER";

  const [workflowData, setWorkflowData] = useState([]);
  const [step, setStep] = useState(0);
  const [values, setValues] = useState({ ...EMPTY_FORM });

  const [filter, setFilter] = useState({
    businessAreas: [],
    courseCategories: [],
    roles: [],
    term: [],
    academicGroup: [],
  });

  const [regionData, setRegionData] = useState({ fetching: true, data: [] });
  const [businessArea, setBusinessAreaData] = useState({
    fetching: true,
    data: [],
  });
  const [careerData, setCareerData] = useState({ fetching: true, data: [] });
  const [courseCategoryData, setCourseCategoryData] = useState({
    fetching: true,
    data: [],
  });

  const [allActiveTerms, setAllActiveTerms] = useState({
    fetching: true,
    data: [],
  });
  const [allActiveAcademicGroup, setAllActiveAcademicGroup] = useState({
    fetching: true,
    data: [],
  });
  const [roleData, setRoleData] = useState({ fetching: true, data: [] });
  const [fetching, setFetching] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleteing, setDeleteting] = useState();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedConfig, setSelectedConfig] = useState(null);

  const getAllInitailList = async () => {
    try {
      setFetching(true);
      const p = await Promise.all([
        dropdownMapping(endpoint?.region.getAllActive, "regionDispValue"),
        dropdownMapping(
          endpoint?.businessArea.getAllCached,
          "businessAreaDispValue"
        ),
        dropdownMapping(
          `${endpoint?.courseCategory.getAllActiveCourseCategory}`,
          "courseAttributeValueDispValue"
        ),
        dropdownMapping(`${endpoint?.term?.getAllActive}`, "termDispValue"),
        dropdownMapping(
          `${endpoint?.academic_group.getAllActive}`,
          "academicGroupDispValue"
        ),
        dropdownMapping(
          `${endpoint?.getRole.roleWithApprovalPermissions}`,
          "roleName"
        ),
        dropdownMapping(
          `${endpoint?.courseCategory.getAllCourseCategoryForOtherChargesConfig}`,
          "courseAttributeValueDispValue"
        ),
        dropdownMappingNew(
          endpoint.academic_career.getAllActive,
          "academicCareerDispValue",
          "academicCareerDispValue"
        ),
      ]);


      setRegionData({ fetching: false, data: p[0] });
      setBusinessAreaData({ fetching: false, data: p[1] });
      if (isRegularCharges) {
        setCourseCategoryData({ fetching: false, data: p[2] });
      } else {
        setCourseCategoryData({ fetching: false, data: p[6] });
      }
      setAllActiveTerms({ fetching: false, data: p[3] });
      setAllActiveAcademicGroup({ fetching: false, data: p[4] });
      setRoleData({ fetching: false, data: p[5] });
      setCareerData({ fetching: false, data: p[7] });

      return p;
    } catch (err) {
      console.error(err);
    } finally {
      setFetching(false);
    }
  };

  const getAllRecords = async (businessAreas = businessArea?.data) => {
    try {
      setFetching(true);
      const request = {
        businessAreas: businessAreas?.map((i) => i.value),
        chargeType,
      };

      const response = await fetchAllPostPromisedData(
        endpoint.concessionConfig.search,
        request,
        "post"
      );
      if (response?.code === 200) {
        setWorkflowData(response.data);
      } else {
        setWorkflowData([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setFetching(false);
    }
  };

  const getAllFilteredRecords = async () => {
    setFetching(true);
    const request = {
      businessAreas: filter.businessAreas.map((i) => i.value),
      courseCategories: filter.courseCategories.map((i) => i.value),
      roles: filter.roles.map((i) => i.value),
      chargeType: chargeType,
      terms: filter.term.map((i) => i.value),
      academicGroups: filter.academicGroup.map((i) => i.value),
    };
    const response = await fetchAllPostPromisedData(
      endpoint.concessionConfig.search,
      request,
      "post"
    );
    if (response?.code === 200) {
      setWorkflowData(response.data);
      setFetching(false);
    } else {
      setWorkflowData([]);
      setFetching(false);
    }
  };

  const init = async () => {
    const dropdownData = await getAllInitailList();
    getAllRecords(dropdownData[1]);
  };

  useEffect(() => {
    // getAllInitailList();
    // getAllRecords();
    init();
  }, []);

  const handleEditData = (data) => {
    setValues({ ...data });
    setOpen(true);
  };

  const reset = () => {
    setValues({ ...EMPTY_FORM });
    handleClose();
    getAllRecords();
    setStep(0);
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
    setValues({ ...EMPTY_FORM });
    setStep(0);
  };

  const handleNextStep = async () => {
    if (step === 0) {
      if (!values.region?.length) {
        failureToast("Please select region");
        return;
      }

      if (!values.businessAreas?.length) {
        failureToast("Please select business area");
        return;
      }

      if (!values.courseCategories?.length) {
        failureToast("Please select course category");
        return;
      }

      if (!values.term?.length) {
        failureToast("Please select term");
        return;
      }

      if (!values.academicGroup?.length) {
        failureToast("Please select academic group");
        return;
      }

      setStep(step + 1);
    }

    debugger;

    if (step === 1) {
      if (
        !values.l1ApprovalPercentage ||
        (isRegularCharges && !values?.l1ApprovalOverAllPercentage)
      ) {
        failureToast("Please enter L1 approval percentage");
        return;
      }

      if (!values.l1ApprovalRoles?.length) {
        failureToast("Please select L1 approval roles");
        return;
      }

      if (
        (isRegularCharges && !values.l2ApprovalPercentage) ||
        (isRegularCharges && !values?.l2ApprovalOverAllPercentage)
      ) {
        failureToast("Please enter L2 approval percentage");
        return;
      }

      if (
        values?.l2ApprovalOverAllPercentage &&
        Number(values?.l1ApprovalOverAllPercentage) + 0.09 >
          Number(values.l2ApprovalOverAllPercentage)
      ) {
        failureToast(
          "L2 approval overall percentage must be 0.1 more than L1 overall approval percentage"
        );
        return;
      }

      if (values.l2ApprovalPercentage && !values.l2ApprovalRoles?.length) {
        failureToast("Please select L2 approval roles");
        return;
      }

      if (
        (isRegularCharges && !values.l3ApprovalPercentage) ||
        (isRegularCharges && !values?.l3ApprovalOverAllPercentage)
      ) {
        failureToast("Please enter L3 approval percentage");
        return;
      }

      if (
        values.l3ApprovalOverAllPercentage &&
        Number(values?.l2ApprovalOverAllPercentage) + 0.09 >
          Number(values?.l3ApprovalOverAllPercentage)
      ) {
        failureToast(
          "L3 overall approval percentage must be 0.1 more than L2 overall approval percentage"
        );
        return;
      }

      if (values.l3ApprovalPercentage && !values.l3ApprovalRoles?.length) {
        failureToast("Please select L3 approval roles");
        return;
      }
      setStep(step + 1);
    }

    if (step === 2) {
      if (isRegularCharges && !values.documentUploadPercentCriteria) {
        failureToast(
          "Please mention the Concession cutoff to make the Document Upload Mandatory."
        );
        return;
      }

      setSaving(true);
      const request = {
        ...values,
        businessAreas: values.businessAreas
          .map((item) => {
            return item.value && item.value !== "*" ? item.value : null;
          })
          .filter((i) => i),
        courseCategories: values.courseCategories.map((item) => item.value),
        terms: values.term.map((item) => item.value),
        academicGroups: values.academicGroup.map((item) => item.value),
        l1ApprovalRoles: values.l1ApprovalRoles.map((item) => item.value),
        l2ApprovalRoles: values.l2ApprovalRoles.map((item) => item.value),
        l3ApprovalRoles: values.l3ApprovalRoles.map((item) => item.value),
        chargeType: isRegularCharges ? "REGULAR" : "OTHER",
        career:values?.carrier?.label
      };

      const url = values?.id
        ? `${endpoint.concessionConfig.update}/${values.id}`
        : endpoint.concessionConfig.create;
      const method = values?.id ? "put" : "post";

      putpost(
        url,
        (data) => {
          setSaving(false);
          successToast(data.message);
          reset();
        },
        (data) => {
          failureToast(data.message);
          setSaving(false);
        },
        request,
        method
      );
    }
  };

  const handleCloseConfimation = () => {
    setSelectedConfig(null);
    setOpenDeleteDialog(false);
  };

  const deleteConfig = async (index) => {
    setDeleteting(true);
    const deleteRecord = await fetchDeletePromisedData(
      `${endpoint.concessionConfig.delete}/${workflowData[index].id}`
    );
    if (deleteRecord?.code === 200) {
      successToast(deleteRecord["message"]);
      setDeleteting(false);
      handleCloseConfimation();
      getAllRecords();
    } else {
      setDeleteting(false);
    }
  };

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center">
        <div className="large-text color-dark">
          Custom concession configuration
        </div>
        <div className="d-flex flex-row">
          <Filter
            businessAreaData={businessArea}
            roleData={roleData}
            courseCategoryData={courseCategoryData}
            allActiveTerms={allActiveTerms}
            allActiveAcademicGroup={allActiveAcademicGroup}
            getFilteredData={getAllFilteredRecords}
            getAllData={getAllRecords}
            filter={filter}
            setFilter={setFilter}
          />
          <CustomButton
            className={"regular-large-bold mx-1"}
            content={"Add config."}
            icon={false}
            permissionType={"C,U,R,D"}
            permissionSet={"C,U,R,D"}
            onClick={handleOpen}
          />
        </div>
      </div>

      {fetching ||
      regionData?.fetching ||
      businessArea?.fetching ||
      roleData?.fetching ||
      courseCategoryData?.fetching ? (
        <CustomLoader
          apiLoader={
            fetching ||
            regionData?.fetching ||
            businessArea?.fetching ||
            roleData?.fetching ||
            courseCategoryData?.fetching
          }
          loaderHeight={"100%"}
          loaderWidth={"100%"}
        />
      ) : workflowData?.length ? (
        <div className="workflow-list-tab-wrapper mt-4 pt-3 pb-4">
          {workflowData.map((item, index) => {
            return (
              <DetailCard
                data={item}
                regionData={regionData}
                businessAreaData={businessArea}
                roleData={roleData}
                categoryData={courseCategoryData}
                allActiveTerms={allActiveTerms}
                allActiveAcademicGroup={allActiveAcademicGroup}
                deleteCurrent={() => {
                  setSelectedConfig(index);
                  setOpenDeleteDialog(true);
                }}
                isDeleting={deleteing}
                isSaveing={saving}
                handleEditData={handleEditData}
              />
            );
          })}
        </div>
      ) : (
        <div
          style={{ height: "80vh" }}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <>
            <div>
              <img src={document} width={54} height={60} />
            </div>
            <div
              className="large-text color-black pb-4 pt-4 text-center"
              style={{ width: "376px" }}
            >
              Click here to add first
              <br />
              Custom concession configuration
            </div>
            <CustomButton
              className={"regular-large-bold"}
              content={"Add config"}
              icon={false}
              permissionType={"C,U,R,D"}
              permissionSet={"C,U,R,D"}
              onClick={handleOpen}
            />
          </>
        </div>
      )}
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <div className="pl-4 pr-4 pt-3 pb-3 concession_workflow">
          <div className="d-flex justify-content-between pb-4">
            <div className="regular-large-bold label-color">
              Add custom concession configuration{" "}
            </div>
            {/* <div><img onClick={handleClose} src={closeIcon} width={20} height={20} /></div> */}
            <div
              onClick={handleClose}
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#E7685A",
                cursor: "pointer",
              }}
            >
              Close
            </div>
          </div>
          {step === 0 ? (
            <BasicDetails
              regionData={regionData}
              businessArea={businessArea}
              courseCategoryData={courseCategoryData}
              careerData={careerData}
              allActiveTerms={allActiveTerms}
              allActiveAcademicGroup={allActiveAcademicGroup}
              values={values}
              setValues={setValues}
            />
          ) : (
            <ClosedStep title="1. Basic details" setStep={() => setStep(0)} />
          )}
          {step === 1 ? (
            <ApprovalSetting
              roleData={roleData}
              values={values}
              setValues={setValues}
              isRegularCharges={isRegularCharges}
            />
          ) : step > 1 ? (
            <ClosedStep
              title="2. Approval setting"
              setStep={() => setStep(1)}
            />
          ) : null}
          {step === 2 ? (
            <DocumentUpload values={values} setValues={setValues} />
          ) : (
            ""
          )}

          <div className=" d-flex justify-content-between align-items-center mt-2">
            {/* <Row style={{ gap: 10 }} className='justify-content-between align-items-center'> */}
            <div className="d-flex align-items-center">
              <img src={infoIcon} width={20} height={20} />
              <div className="semi-bold color-grey-60 pl-1">
                All fields are mandatory
              </div>
            </div>
            <div>
              <CustomButton
                className="regular-large-bold pl-5 pr-5 pt-1 pb-1"
                content={
                  saving ? (
                    <i className="fas fa-spinner fa-spin" aria-hidden="true">
                      {""}
                    </i>
                  ) : step === 2 ? (
                    "Save config."
                  ) : (
                    "Next"
                  )
                }
                permissionType={"C,U,R,D"}
                permissionSet={"C,U,R,D"}
                onClick={handleNextStep}
              />
            </div>
            {/* </Row> */}
          </div>
        </div>
      </Dialog>
      <ConfirmationDeleteDialog
        isOpen={openDeleteDialog}
        onAgree={() => {
          deleteConfig(selectedConfig);
        }}
        setIsOpen={handleCloseConfimation}
        headerMsg={"Confirm configuration delete"}
        msg={`Are you sure you want to delete the selected configuration?`}
      />
    </Container>
  );
};

export default ConcessionWorkflow;
